import React from 'react';
import { formatPrice } from '../../utils/helpers';

const STATUS_STYLES = {
  in_transit: 'bg-purple-500/15 text-purple-300',
  pending: 'bg-amber-500/15 text-amber-300',
  frozen: 'bg-sky-500/15 text-sky-300',
  completed: 'bg-green-500/15 text-green-300',
  refunded: 'bg-gray-500/20 text-gray-300',
  failed: 'bg-red-500/15 text-red-300',
  rejected: 'bg-red-500/15 text-red-300',
};

const STATUS_LABELS = {
  in_transit: 'En transito', pending: 'Pendiente', frozen: 'Congelado', completed: 'Completado',
  refunded: 'Reembolsado', failed: 'Fallido', rejected: 'Rechazado',
};

export const TxnStatusBadge = ({ status }) => (
  <span className={`text-xs px-2 py-0.5 rounded-full ${STATUS_STYLES[status] || 'bg-gray-700 text-gray-300'}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export const TxnTable = ({ txns, renderActions, testid }) => (
  <div className="overflow-x-auto" data-testid={testid}>
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-gray-700 bg-gray-900/50 text-gray-400">
          <th className="text-left p-2 font-medium">Fecha</th>
          <th className="text-left p-2 font-medium">Tipo</th>
          <th className="text-left p-2 font-medium">Detalle</th>
          <th className="text-right p-2 font-medium">Monto</th>
          <th className="text-center p-2 font-medium">Estado</th>
          {renderActions && <th className="text-center p-2 font-medium">Acciones</th>}
        </tr>
      </thead>
      <tbody>
        {txns.length === 0 ? (
          <tr><td colSpan={6} className="p-6 text-center text-gray-500">Sin movimientos</td></tr>
        ) : txns.map((t, i) => (
          <tr key={t.txn_id || i} className="border-b border-gray-700/50" data-testid={`${testid}-row-${i}`}>
            <td className="p-2 text-gray-400 text-xs whitespace-nowrap">{t.created_at ? new Date(t.created_at).toLocaleString('es-MX') : '—'}</td>
            <td className="p-2 text-gray-300 text-xs">{t.type}</td>
            <td className="p-2 text-gray-400 text-xs">
              {t.note || (t.order_id ? `Pedido #${t.order_id.slice(0, 8)}` : '—')}
              {t.internal_id && <span className="block font-mono text-[10px] text-gray-500">{t.internal_id}</span>}
            </td>
            <td className={`p-2 text-right font-mono ${t.amount < 0 ? 'text-red-400' : 'text-green-400'}`}>{formatPrice(t.amount || 0)}</td>
            <td className="p-2 text-center"><TxnStatusBadge status={t.status} /></td>
            {renderActions && <td className="p-2 text-center">{renderActions(t, i)}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
